export default {
  mensagens () {
    return [
      {
        id: 1,
        texto: 'Campo Obrigatório'
      },
      {
        id: 2,
        texto: 'Registro incluído com sucesso.'
      },
      {
        id: 3,
        texto: 'Registro alterado com sucesso.'
      },
      {
        id: 4,
        texto: 'Registro excluído com sucesso.'
      },
      {
        id: 5,
        texto: 'Deseja mesmo excluir este registro?'
      },
      {
        id: 6,
        texto: 'Nenhum registro encontrado.'
      },
      {
        id: 7,
        texto: 'Mostrando {0} até {1} de {2} registros.'
      },
      {
        id: 8,
        texto: 'O sistema já possui um registro com o {0} informado.'
      },
      {
        id: 9,
        texto: 'A consulta está restrita a cem (100) registros. Se o registro procurado não retornou, adicione mais parâmetros à consulta.'
      },
      {
        id: 10,
        texto: 'Este registro não pode ser excluído.'
      },
      {
        id: 11,
        texto: 'O campo {0} é obrigatório.'
      },
      {
        id: 12,
        texto: 'Em construção.'
      },
      {
        id: 13,
        texto: 'Não há registro para salvar.'
      },
      {
        id: 14,
        texto: 'Não houve alterações.'
      },
      {
        id: 15,
        texto: 'E-mail enviado com sucesso.'
      },
      {
        id: 16,
        texto: 'Erro na configuração do e-mail.'
      },
      {
        id: 17,
        texto: 'Deseja mesmo excluir a junção inteira?'
      },
      {
        id: 18,
        texto: 'Deseja mesmo excluir esse processo da junção?'
      },
      {
        id: 19,
        texto: 'Junção excluída com sucesso.'
      },
      {
        id: 20,
        texto: 'Processo excluído da junção com sucesso.'
      },
      {
        id: 21,
        texto: 'O grid view não tem nenhum elemento.'
      },
      {
        id: 22,
        texto: 'Não é possível selecionar o mesmo processo como Principal e Secundário.'
      },
      {
        id: 23,
        texto: 'Deve existir pelo menos um processo Principal e um Secundário.'
      },
      {
        id: 24,
        texto: 'Os processos a serem juntados devem possuir o mesmo Tipo Processo, Assunto e Subassunto.'
      },
      {
        id: 25,
        texto: 'Não é possível trocar o processo Principal pois a junção já foi movimentada.'
      },
      {
        id: 26,
        texto: 'Não é possível excluir um processo Secundário que já foi movimentado com a junção.'
      },
      {
        id: 27,
        texto: 'Deseja mesmo excluir o Roteiro inteiro?'
      },
      {
        id: 28,
        texto: 'Roteiro excluído com sucesso.'
      },
      {
        id: 29,
        texto: 'Deseja mesmo confirmar o Documento?'
      },
      {
        id: 30,
        texto: 'Documento confirmado.'
      }
    ]
  },
  // Método que recupera a mensagem passando o código da mensagem e os parâmetros
  m (id, ...param) {
    // Recuperando a mensagem por código
    let msg = this.mensagens().filter(m => m.id === id)[0].texto
    if (msg && param) {
      for (var i = 0; i < param.length; i++) {
        // Substituindo os parâmetros
        msg = msg.replace('{' + i + '}', param[i])
      }
    }
    return msg
  }
}
